module.exports = __webpack_public_path__ + "static/media/xiraForLawyers1.e2a56b17.mp4";